import { useTranslation } from '@/app/providers';
import { useActiveBranch } from '@/features/auth/hooks/use-active-branch';

export function AdminFooter() {
  const { t } = useTranslation();
  const { branchName } = useActiveBranch();
  const year = String(new Date().getFullYear());

  return (
    <footer className="flex shrink-0 items-center justify-center gap-2 border-t border-surface-border bg-surface px-4 py-3 text-sm text-surface-muted sm:px-8 md:px-12">
      <div className="flex shrink-0 flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <span className="truncate text-white/80">{branchName ?? ''}</span>
        <span className="text-white/80">|</span>
        <span>{t('common.footer', { year })}</span>
      </div>
    </footer>
  );
}
